import React from 'react';
import { SettingsSecurityCard } from './SettingsSecurityCard';

export const SettingsSecuritySection: React.FC = () => {
  return (
    <div className="space-y-6">
      <SettingsSecurityCard />
    </div>
  );
};

export default SettingsSecuritySection;
